import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { RemarksRuleData as RuleData } from "../../state/BookingCreateManager/RemarksRuleData";
import { shallowValidationCheck } from '../../../utils/ValidationUtils';

const updateRuleData: Reducer<RuleData> = (state: RuleData = new RuleData(), action: Action<ActionType, RuleData>) => {
  switch (action.type) {
    case ActionType.BOOKING_CREATE_MANAGER_REMARKS_RULE_DATA_RESET:
      return new RuleData();
    case ActionType.BOOKING_CREATE_MANAGER_REMARKS_RULE_DATA_FETCHED:
      return { ...state, ruleFormData: action.data };
    case ActionType.BOOKING_CREATE_MANAGER_REMARKS_RULE_DATA_UPDATED:
      return { ...state, ruleFormData: { ...state.ruleFormData, ...action.data } };
    case ActionType.BOOKING_CREATE_MANAGER_REMARKS_RULE_DATA_VALIDATED:
      let isValid = shallowValidationCheck(action.data);
      return { ...state, validation: action.data, readyToSaveRuleForm: isValid };
    case ActionType.BOOKING_CREATE_MANAGER_REMARKS_RULE_DATA_SAVED:
      return { ...state, readyToSaveRuleForm: false };
    case ActionType.BOOKING_CREATE_MANAGER_REMARKS_RULE_DATA_SET_BRAND_AND_MARKET:
      return { ...state, ruleFormData: {brandAndMarket: action.data} };
    default:
      return state;
  }
};

export default updateRuleData;
